export const EN = {

index:{
    title_general: "Dive Simulator",
    que_hace_txt: "What it does?",
    objetivo: "The goal is not to simulate diving, it is to improve the real diver.",
    modelos_txt_1: "Models",
    instrumentos_txt: "Instruments",
    seguridad_txt: "Safety",

    que_se_pierde: "What is lost when teaching diving without simulation?",

teoria_de_perdida: `

        <span style="color:#dfbb73;font-size: 20px;">"Theory teaches what to do. Simulation teaches why to do it"</span>

        <br><br>Without simulation, many concepts remain abstract. Students memorize limits, procedures, and tables, but struggle to visualize how their decisions actually affect gas absorption, decompression, oxygen exposure, and dive safety.
        <br><br>Simulation transforms invisible processes into visual and interactive experiences. It allows them to experiment with scenarios, analyze consequences, and understand how small changes in depth, time, or ascent rate can modify an entire dive profile.
        <br><br>For instructors, it means moving from explaining concepts to demonstrating how they work in real time.
        <br><strong>Because the goal is not for the student to remember a rule. It is for them to understand the consequences of their decisions before entering the water.</strong>`,


    faq_txt: "FAQ",
    login_txt: "Login",
    
    experiencia_interactiva: "Diving simulator | Dry training",

    que_hace_2: "<strong>Divantys</strong> helps you understand diving before entering the water. Reducing risk, accelerating learning, and improving real decisions under pressure.",    openModalBtn: "View summary",


   visualiza: "Master diving theory. <strong>Learn to manage and optimize your dives</strong> before touching the water",
    que_hace_4: `
                <strong>Diving is expensive; learning doesn't have to be.</strong><br>
                Practice in the simulator, not during a dive you're paying for.<br>
                Train on dry land, build experience, and make the most of every minute of your underwater adventure.`,



        all_levels: "For beginner divers and students up to advanced divers and instructors", 
safety_gestion: "Manage and perform safety stops",
aire_profundidad: "Extend your dives by managing depth",
gestion_deco: "Manage and perform your decompression stops",
ppo2_gestion: "Manage and visualize PPO2 with depth",


        ilustra: `
        The simulator teaches you to act correctly to mistakes,
          showing you the future of your decisions before you get into the water.
        `,
        preguntas_estrategicas_aprendizaje: `
        So the really important question is:<br>
          <ul>
            <li>What would happen if I made a different decision?</li>
            <li>What happens if I stay five more minutes at the bottom?</li>
            <li>What happens if I ascend too fast?</li>
            <li>How do my tissues change if I use another gas mixture?</li>
            <li>How does a deeper or longer stop affect my decompression profile?</li>
          </ul>
        Simulation allows these questions to be answered immediately, visually and safely.`,

    relacion_pp: "Anticipating the error is a diver's greatest progress",
    ndl: "No Decompression Limits (NDL)",
    absorcion: "Nitrogen absorption (tissues)",
    exposicion: "Oxygen exposure (PPO₂ / CNS)",
    habitos_asenso: "Safer ascent habits",
    consumo_aire: "Air consumption and reserve",
    buceo_recreativo: "Recreational diving",
    nitrox_compatible: "Nitrox compatible",
    hud: "On-screen HUD",
    mobil_desktop: "Mobile + Desktop",
    startCta: "Enter free simulator",
    que_incluye: "See what's included",
    tiempo: "Tip: you can speed up time to observe the evolution of indicators faster (for example 2×, 5×, or 10×).",
    que_hace_3: "What this simulator does?",
    inmersion_virtual: "Divantys Dive Simulator is an interactive diving simulation and learning platform that allows you to visually and in real time observe the physical and physiological processes that occur during a dive. Its goal is to transform complex concepts of diving theory, decompression, and human physiology into an easy-to-understand visual experience for divers, students, instructors, and industry professionals. Divantys works as a virtual laboratory where you can explore how the human body responds to different dive profiles, gas mixtures, depths, and exposure times.",
    experiencia_3d: "Controllable 3D experience",
    movimiento_cacara: "Movement and camera with controls adapted to mobile, tablet, and PC.",
    joistick_movimiento: "Movement joystick",
    joistick_rotacion: "Look/rotation joystick",
    neutral_flotabilidad: "Neutral zone for stability",
    indicadores_hud: "HUD indicators",
    instrumentos_visuales: "On-screen visual instruments for immediate understanding.",
    tanque: "Tank: bar / PSI / percentage",
    barra_nitrogeno: "Nitrogen bar (educational)",
    ndl_estado: "NDL and ascent status",
    reporte: "Full report",
    resumen: "Dive summary for learning and analysis.",
    profundidad_maxima: "Maximum depth",
    tiempo_total: "Total time",
    ndl_total: "Total and remaining NDL",
    ceiling: "Ceiling (minimum safe depth)",
    modelos_txt: "Models and concepts represented",
    simulador_implementa: "The simulator implements physiological models and common educational rules in recreational diving: nitrogen absorption and release by tissues, no-decompression limits, and oxygen exposure.",
    modelo_tejidos: "Tissue model (16 compartments)",
    simulador_carge_nitrogeno: "Simulates nitrogen loading in different tissues at different speeds, allowing estimation of saturation, “ceiling”, and behavior in repetitive dives.",
    expoosicion_o2: "Oxygen exposure (PPO₂ / CNS)",
    calculo_po2: "Calculates PPO₂ based on depth and fraction of oxygen (FO₂), and accumulates CNS exposure with a PPO₂ limits model. Includes alert levels (OK / WARNING / DANGER).",
    ndl2: "NDL (No Decompression Limit)",
    caluclo_ndl: "Calculates a “recreational” NDL based on depth and time, with Nitrox support (EAD).",
    ndl_total_permitido: "Total allowed NDL",
    ndl_restante: "Remaining NDL according to the profile",
    interpretacion_riesgos: "Educational risk interpretation",
    ceiling_asecenso: "Ceiling and ascent",
    estimacion_profundidad_ceiling: "Estimates a minimum safe depth (ceiling) and evaluates if the ascent can be made without stops.",
    ceiling_metros: "Ceiling in meters",
    deteccion_parada: "Required stop” detection",
    recomendacion_parada: "Safety stop recommendation",
    inmersiones_repetitivas: "Repetitive dives",
    carga_residual: "Maintains residual load between dives and simulates surface intervals.",
    tejidos_conservan: "Tissues are preserved between dives",
    intervalo_superficie: "Surface interval reduces load",
    aprendizaje_acumulacion: "Residual accumulation learning",
    instrumentos_visualizacion_hud: "Instruments and visualization (HUD)",
    facilitar_comprension: "To facilitate understanding, the simulator shows visual instruments on screen during the dive. Its purpose is for the user to “see” how concepts change with their behavior.",
    tanque_aire: "Air tank (AL80)",
    simula_consumo_sac: "Simulates consumption according to SAC, ambient pressure, and simulated time.",
    presion_bar_psi: "Pressure in bar and PSI",
    gas_restante: "Remaining percentage",
    alerta_reserva: "Reserve alert (e.g., 35 bar)",
    sin_aire: "Out of air” status",
    barra_nitrogeno_2: "Nitrogen bar",
    visualizacion_educativa: "Educational visualization of load increase/decrease.",
    suavisado_visual: "Visual smoothing (slow loading / normal unloading)",
    colores_nivel: "Colors by level (green→red)",
    enfoque_didactico: "Didactic approach, easy to interpret",
    ndk_y_estado_ascenso: "NDL and ascent status",
    indicadores_limites_descompresion: "Indicators to understand no-decompression limits and ascent habits.",
    ndl_restante_2: "Remaining NDL",
    recomendacion_parada_2: "Safety stop recommendation",
    ceiling_si_aplica: "Ceiling (if applicable)",
    escala_tiempo_safety_stop: "Time scale (1×, 2×, 5×, 10×)",
    acelerar_tiempo: "You can speed up the simulation to observe how values change faster. This function is useful for education: it shows the trend of indicators without having to wait for long periods.",
    safety_stop_title: "Safety Stop (Recreational safety stop)",
    safety_stop_resumen: "This module simulates the 5-meter safety stop in recreational diving. Its logic is based on scaled real-time control, depth tolerance, and detection of interruptions or redescents to validate or invalidate the stop.",
    deteccion_recomendacion: "Stop recommendation",
    safety_recommendation_meta: "The stop is automatically recommended according to the dive profile.",
    profundidad_maxima_safety_stop: "Activated if maximum depth exceeds 10 m",
    exclusion_descompresion: "Deactivated if there is active or required deco",
    estado_recomendado: "Status: recommended → activates the safety stop",
    callback_recomendacion: "Optional user notification callback",
    logica_ejecucion: "Execution logic",
    safety_execution_meta: "The system controls time in the 5-meter zone with tolerance and temporal scaling.",
    zona_parada: "Stop zone: 5 m ± 2 m",
    zona_pausa: "Pause zone: 5 m - 3 m (no progress)",
    acumulacion_tiempo_safety_stop: "Time accumulation in simulated seconds",
    escala_tiempo: "Scaling by simulation speed (GET_TIME_SCALE)",
    completado_3min: "Completed after 180 effective seconds",
    pausa_reanuda: "Automatic pause upon leaving the zone",
    interrupciones_redescenso: "Interruptions and redescent",
    safety_interrupt_meta: "Detects if the diver leaves the stop or returns to depth after completing it.",
    rompe_parada: "Leaving the zone invalidates progression",
    cancelacion: "Cancelled status activates tracking reset",
    interrupted_flag: "Marks interruption if logic is broken",
    redescenso_invalida: "Redescent &gt; 6 m resumes recommendation",
    ventana_tiempo: "30 s window for post-completion invalidation",
    safety_stop_tiempo: "Stop time control",
    safety_stop_explicacion: "Time is calculated in simulated real time, accumulating only when the diver remains within the correct range. If they leave the zone, the counter pauses. If they complete the 3 effective minutes, the stop is marked as completed. However, a subsequent redescent can invalidate it under certain physiological conditions.",
    nitrogen_load_title: "Nitrogen load bar (Educational UI)",
    nitrogen_load_resumen: "This module visualizes the nitrogen load in the diver's fast tissues in real time. Its goal is educational: to show how relative saturation evolves during the dive using a smoothed, color-coded progress bar.",
    visualizacion_n2: "N₂ load visualization",
    n2_visual_meta: "Represents the nitrogen saturation level in fast tissues in a simplified way.",

     ppo2_vizualiza:"PPO₂ and CNS",
    ppo2_visualiza_desc:"Visualize oxygen toxicity using PPO₂ and accumulated CNS exposure. Status is represented through physiological risk levels.",
    ppo2_visualiza_p1:"Illustrative toxicity level colors",
    ppo2_visualiza_p2:"Accumulated CNS",

    profundimetro:"Real-time Depth",
    profundimetro_educativa:"Continuous depth monitoring to better understand the evolution of the dive profile.",
    profundimetro_visualiza_p1:"Dynamic depth updates throughout the entire dive.",
    profundimetro_visualiza_p2:"Visual smoothing that simulates the behavior of real instruments.",


    tejidos_rapidos: "Based on fast tissues from the physiological model",
    valor_porcentual: "Value expressed as a percentage (0–130%)",
    suavizado_visual_2: "Visual smoothing to prevent sudden jumps",
    actualizacion_tiempo_real: "Real-time update",
    codigo_colores_n2: "Color coding",
    n2_colors_meta: "The bar changes color according to the load level for quick interpretation.",
    verde_seguro: "Green: low and stable load (&lt; 60%)",
    amarillo_atencion: "Yellow: caution zone (60%–85%)",
    naranja_alto: "Orange: high load (85%–100%)",
    rojo_riesgo: "Red: potential oversaturation (&gt; 100%)",
    logica_suavizado: "Smoothing and stability logic",
    n2_smoothing_meta: "The visual value does not change instantly, but progressively approaches the real value.",
    interpolacion_visual: "Progressive interpolation (ease-in / ease-out)",
    respuesta_diferencial: "Slower response to increase than to decrease",
    prevencion_flicker: "Visual flicker prevention",
    clamp_visual: "Clamp values between 0% and 130%",
    n2_bar_texto_secundario: "Secondary information (GF / physiological state)",
    n2_bar_explicacion: "The bar can include additional text (such as Gradient Factor or the model's physiological state). This allows visual correlation of nitrogen saturation with decompression status, offering a more intuitive representation of accumulated risk.",
    air_consumption_title: "Air consumption (multi-tank AL80)",
    air_consumption_resumen: "This module simulates actual gas consumption in dynamic time using SAC (Surface Air Consumption), ambient pressure, and time scale. It supports single or multi-tank configurations and calculates progressive depletion of the entire system.",
    modelo_consumo: "Consumption model",
    air_model_meta: "Consumption is based on the diver's SAC adjusted by ambient pressure and simulated time.",
    sac_rate: "User-configurable SAC",
    presion_ambiente: "Ambient pressure = 1 + depth/10",
    escala_tiempo_aire: "Scaled by GET_TIME_SCALE()",
    consumo_proporcional: "Proportional consumption per tank",
    sistema_multitanque: "Multi-tank system",
    air_tanks_meta: "The system distributes consumption among all active tanks of the equipment.",
    al80_base: "Base tank AL80 (2265 L)",
    multi_tank_support: "Multi-tank support",
    division_consumo: "Consumption divided between active tanks",
    estado_out_of_air: "Global OUT OF AIR status",
    visualizacion_hud_aire: "HUD visualization",
    air_hud_meta: "Each tank is represented with a vertical level bar and pressure reading in bar and PSI.",
    nivel_visual_barra: "Visual level by volume percentage",
    bar_psi_conversion: "Real-time bar / PSI conversion",
    colores_reserva: "Color based on reserve (green → orange → red)",
    alerta_reserva_aire: "Alert below 35 bar",
    air_system_tank_title: "Air system status",
    air_system_explainer: "The system calculates the total remaining volume by adding up all active tanks. Consumption is updated on each simulated frame and allows detection of the reserve point or the critical 'out of air' condition. The model reflects both individual and global consumption.",
    oxygen_toxicity_title: "Oxygen toxicity (NOAA CNS)",
    oxygen_toxicity_resumen: "This module evaluates the risk of oxygen toxicity using PPO₂ and accumulated CNS. The status is represented through dive computer-style physiological risk levels.",
    ppo2_model: "Oxygen partial pressure (PPO₂)",
    ppo2_meta: "Determines the immediate risk of acute toxicity.",
    formula_ppo2: "PPO₂ = FO₂ × ambient pressure",
    limite_ppo2: "Operating limit: 1.4 bar",
    limite_critico: "Critical: ≥ 1.6 bar",
    cns_model: "CNS (Central Nervous System)",
    cns_meta: "Progressive accumulation of oxygen exposure according to the NOAA model.",
    noaa_model: "NOAA exposure model",
    acumulacion_cns: "Progressive increase over time",
    limite_cns: "100% = recommended limit",
    estado_oxigeno: "Toxicity status",
    oxy_state_meta: "Combined real-time evaluation of PPO₂ and CNS.",
    stateOK: "OK",
    stateWARN: "WARNING",
    stateDANGER: "DANGER",
    state_ok: "OK: exposure within safe limits",
    state_warning: "WARNING: caution zone",
    state_danger: "DANGER: risk of acute toxicity",
    oxygen_system_title: "Oxygen risk model",
    oxygen_system_explainer: "The system combines acute toxicity (PPO₂) and cumulative toxicity (CNS). The displayed status reflects the dominant risk level at each moment of the dive, similar to a real technical dive computer.",
    logica_deco_engine: "Decompression engine logic (Bühlmann + GF)",
    resumen_logica_deco: "This module calculates the diver's decompression plan in real time by simulating tissue saturation with nitrogen, generating mandatory stops, and adjusting the ascent profile according to the physiological state and the safety gradient (GF). It also maintains a persistent history to avoid losing progress between plan regenerations.",
    generacion_plan: "Decompression plan generation",
    plan_buhlmann: "The system builds a stop profile based on the Bühlmann model with Gradient Factors.",
    calculo_ceiling: "Ceiling calculation with GF line (safe ascent limit)",
    redondeo_paradas: "Rounding to stop steps (STOP_STEP_M)",
    simulacion_exposicion: "Tissue load simulation per stop",
    condicion_fin: "Ends when the ceiling drops below 3 m (STOP_REQUIRED_M)",
    modo_preview: "Preview mode without affecting real history",
    historial_persistencia: "Stop history and persistence",
    deco_history: "The system saves the progress of each stop to avoid loss of state during regenerations.",
    decohistory_array: "decoHistory stores progress by depth",
    hydrate_paradas: "Hydration of stops from history",
    preserva_progreso: "Preserves performed time (timePerformedSec)",
    evita_reset: "Avoids resets of already started stops",
    merge_plan: "Merge between new plan and previous state",
    update_deco_logic: "The engine continuously recalculates decompression status based on depth, simulated time, and tissues.",
    control_parada_actual: "Current stop control with depth tolerance",
    bloqueo_orden: "Order locking (do not skip previous stops)",
    regeneracion_dinamica: "Regeneration if the profile worsens or improves",
    acumulacion_tiempo: "Time accumulation by dtSimSec",
    auto_complete: "Auto-complete at 95% compliance",
    tts_dinamico: "Dynamic TTS calculation (ascent + stops)",
    tts_resumen: "Total Time to Ascent (TTS)",
    tts_explicacion: "TTS is calculated by combining the leg-by-leg ascent time (based on ascent rate) plus the remaining time in active decompression stops. The result is continuously adjusted based on the actual tissue status and the current plan.",
    uso_responsable: "Responsible use and important notice",
    herramienta_educativa: "This project is an educational and illustrative tool. Real diving requires training, certified equipment, and professional supervision.",
    importante: "Important",
    que_hace_3_txt: "This simulator is <strong>not</strong> a diving course, does <strong>not</strong> replace formal training, and is <strong>not</strong> a dive computer or an operational planning tool. It <strong>must not</strong> be used to plan real dives or for decision-making. Everything shown is <strong>solely illustrative</strong>, using concepts and algorithms applied only for simulation and visualization purposes. The use of the simulator is the user's responsibility.",
    ackCheck: "",
    entiendo_educativo: "I understand that this simulator is for educational purposes only, does not replace certified training or a dive computer, and must not be used to plan or execute real dives.",
    enterBtn: "Enter the simulator",
    learnMoreBtn: "View system details",
    faq_txt_2: "Frequently Asked Questions",
    que_es: "Is this a dive planner?",
    es_aprendizaje_visual: "No. It is a visual learning tool. It should not be used to plan real dives.",
    que_gases_contempla: "What gases does it consider?",
    cuales_gases: "Air and Nitrox are considered through fraction of oxygen (FO₂), affecting NDL, nitrogen, and PPO₂/CNS.",
    mobil_funciona: "Does it work on mobile?",
    si_funciona_mobil: "Yes. Controls adapt with joysticks and handle pointer events.",

    se_descarga: "Does it need to be downloaded?",
    no_se_descarga: "We use <strong>3D WebGL</strong> technology so you don't need to download it from any app store and can enjoy free, unlimited access directly in your browser.",


    team_txt_2: "Team",
    gonzalo_desc: "Dive Instructor | Software Technician",
    title_footer: "Dive Simulator",
    footer_experiencia: "Educational and illustrative experience",
    consejo_ambiental: "Environmental tip: maintaining buoyancy and conscious movement protects the reef and marine life.",
    modalTitle: "System Summary",
    closeModalBtn: "Close",
    actualiza_indicadores: "The simulator updates safety and physiological indicators during the virtual dive and generates an output report for learning.",
    fisiologia: "Physiology (tissues)",
    compartimentos_2: "16 simulated compartments, nitrogen load, and ceiling/ascent estimation.",
    ndl_nitros: "NDL and Nitrox",
    ndl_recreativo: "Recreational NDL, FO₂ support with equivalent air depth (EAD) at an educational level.",
    consumo_aire_2: "Air consumption",
    consumo_basado_sac: "Consumption based on SAC, ambient pressure, and simulated time; reserve and out-of-air alerts.",
    oxigeno_cns: "Oxygen (PPO₂ / CNS)",
    calculo_ppo2: "Calculates PPO₂ by depth and FO₂; accumulates CNS exposure and shows alerts.",
    fines_educativos: "Note: all values and visualizations are for educational and simulation purposes only.",
    closeSlideBtn: "❌",

    safety_stop_menu: "Safety Stop",
    nitrogen_bar_menu: "N₂ Bar",
    consumo_aire_menu: "Gas Consumption",
    oxicidad_oxigeno_menu: "O2 Toxicity",
    deco_menu: "DECO",
    deco_y_paradas_deco: "DECO and respective decompression stops",

    registro_existoso: "Registration Completed!",
    instrucciones_email_registro: "Your account has been successfully created. Please validate your account in your email to log in! Thank you",
    cintinuar: "Continue",


},


payment_stripe:{

  title:"Secure payment with Stripe",
  ammount_txt:"Total to pay:<br>",
  currency:"Euros",
  pagar_ahora:"Pay Now",
  continuar:"Continue",
  cancelar:"Cancel",
  error: "Error",
  completa_inputs:"Please complete all fields",
  close:"Close",
  error_passwords:"Passwords Error",
  passwords_no_iguales:"Passwords not match",
  error_email: "Error Email",
  ingresa_email_valido:"Please enter a valid email address.",
  user_data:"User Data",
  create_account:"Create a new account",
  pago_exitoso:"Payment successful",
  pago_compeltado:"Your payment has been successfully completed",
  pago_proceso:"Payment in process of accreditation",
  confirmaremos_pago:"We will be waiting to confirm your payment",
  pago_fallido:"Error processing payment",
  fallo_autenticacion_declinado:"Authentication failed or declined",
  status_pago:"Payment status",
  cuenta_existente:"This account already existed",
  cuenta_existente_txt:"This email had already been registered previously"

},



login:{

  iniciar_session: "Log in",
  accede_a_cuenta:"Access your account",
  email:"Email",
  password:"Password",
  iniciar_session_btn:"Log in now",
  verificando:"Verifying.....",
  credenciales_incorrectas:"Incorrect credentials"


},



stripe_user_data:{
  user_data:"User data",
  create_account:"Create a new account",
  username:"Username",
  enter_username:"Enter full name",
  email_user:"User email",
  enter_email:"Enter an email",
  password:"Password",
  enter_password:"Enter a password",
  repeat_password:"Repeat password",
  enter_repeat_password:"Enter the same password",
  seleccion_suscripcion:"Select subscription type",
  mensual:"Monthly",
  semestral:"Semi-annually",
  anual:"Annually"
},




cookies:{

  title:"Cookies Required",
  message:"This website requires cookies to function properly. You must accept their use to continue",
  reject:"Decline",
  accept:"Accept",
  acceso_denegado:"Access denied",
  debes_aceptar:"Cookie authorization is required to continue"

},



condiciones:{

  full:  `  


<div id="legal_conditions" class="legal_conditions">

<div class="legal_header">
<h1>Terms and Conditions of Use</h1>
</div>


<div id="legal_scroll_container" class="legal_scroll_container">


<div class="section_legal">

<h2>1. IDENTIFICATION OF THE RESPONSIBLE PARTY</h2>

<p>
In compliance with Law 34/2002 on Information Society Services (LSSI-CE),
you are informed that this website is owned by:
</p>

<ul>
<li><strong>DIVANTIS</strong></li>
<li><strong>Contact email:</strong> admin@divantys.com</li>
<li><strong>Tax address:</strong> Málaga, Spain</li>
<li><strong>Activity:</strong> provision of remote digital services</li>
</ul>

</div>


<div class="section_legal">

<h2>2. OBJECT AND CONDITIONS OF USE</h2>

<p>
This website offers digital services, interactive content,
and online tools. Accessing the site implies the acceptance
of these conditions.
</p>

<p>The user agrees to:</p>

<ul>
<li>Not engage in unlawful activities</li>
<li>Not introduce malicious code</li>
<li>Not attempt to access restricted systems</li>
<li>Not use the site for fraudulent purposes</li>
</ul>

</div>


<div class="section_legal">

<h2>3. INTELLECTUAL PROPERTY</h2>

<p>
All contents of the site (texts, code, design, software, and images)
are property of the owner or are licensed.
Their reproduction without express authorization is prohibited.
</p>

</div>


<div class="section_legal">

<h2>4. EXCLUSION OF LIABILITY</h2>

<p>
The site is provided "as is". The owner does not guarantee
continuous availability or the absence of technical errors.
</p>

</div>


<div class="section_legal">

<h2>5. PRIVACY POLICY (GDPR)</h2>

<h3>Data collected</h3>

<ul>
<li>Name</li>
<li>Email address</li>
<li>Data submitted through forms</li>
<li>Technical browsing data</li>
</ul>

<h3>Purpose</h3>

<ul>
<li>Respond to inquiries</li>
<li>Send requested information</li>
<li>Improve the service</li>
<li>Commercial communications (with consent)</li>
</ul>

</div>


<div class="section_legal">

<h2>6. INTERNATIONAL TRANSFERS</h2>

<p>
In the event of using technology providers located outside the
European Economic Area, standard contractual clauses
approved by the European Commission will apply.
</p>

</div>


<div class="section_legal">

<h2>7. COOKIE POLICY</h2>

<p>
The site may use technical and analytical cookies
to improve the user experience.
</p>

</div>


<div class="section_legal">

<h2>8. MODIFICATIONS</h2>

<p>
The owner may modify these policies at any time.
Modifications will take effect upon publication.
</p>

</div>


<div class="section_legal">

<h2>9. LEGISLATION AND JURISDICTION</h2>

<p>
These conditions are governed by Spanish law.
The parties submit to the courts of Málaga, Spain.
</p>

</div>


<div class="section_legal">

<h2>10. CONTACT</h2>

<p>
For any inquiries related to these policies:
</p>

<p>
📧 admin@divantys.com
</p>

</div>


</div>



<div class="legal_controls">

<button id="legal_continue_btn">
Accept and continue
</button>

</div>

</div>

    ` 

},



// ===================================================
  // GENERALES
  // ===================================================
  general: {
    ok: "OK",
    cancel: "Cancel",
    salir: "Exit",
    button_fisiologia: "Diving Physiology",
    closeReset: "Close and reset",
    startDive: "Start dive",
    startNextDive: "Start next dive",
    firstDive: "First dive",
    repetitiveDive: "Repetitive dive",
    Dive: "Dive #",
    reduce_ascent_speed: "Reducing ascent speed decreases nitrogen overload.",
    controlled_ascent_text: "Remember that your ascents must be slow and controlled to avoid tissue saturation. Use 'Nitrogen Load' as a reference."
  },

  // ===================================================
  // ALERTAS / MENSAJES
  // ===================================================
  alerts: {
    notice: "Notice",
    invalidSurface: "Invalid surface interval",
    noRepetitive: "Repetitive dives are not allowed after this dive",
    noTissueData: "No tissue data available",
    recalculating: "Recalculating tissue compartments…",

        outOfAir: {
          title: "🚨 Out of Air",
          button: "I understand",
          html: `
            <strong>Critical situation detected.</strong><br><br>

            • Gas supply depleted<br>
            • Initiate a controlled ascent immediately<br>
            • Continuous exhalation (CESA)<br>
            • Maintain a safe ascent rate<br><br>

            <em>This dive has been terminated for safety reasons.</em>
          `
        },
        modExceeded: {
            icon: "🫁⚠️",
            color: "#c62828",
            title: "🚨 MOD exceeded for EAN{{ean}}",
            button: "I understand",
            html: `
              <strong>You are deeper than the safe operating depth for this gas.</strong><br><br>

              <strong>Details:</strong><br>
              • Current depth: <strong>{{depth}} m</strong><br>
              • MOD (PPO₂ 1.4): <strong>{{mod}} m</strong><br>
              • Action: <strong>ascend</strong> immediately to a shallower depth<br><br>

              <em>This dive has been terminated for safety reasons.</em>
            `
          },
          recreationalLimitExceeded: {
            icon: "🚫",
            color: "#c62828",
            title: "🚨 Recreational limits exceeded",
            button: "I understand",
            html: `
              <strong>You have descended beyond the standard limits of recreational diving.</strong><br><br>

              <strong>This means:</strong><br>
              • A recreational NDL does not apply<br>
              • Decompression is likely required<br>
              • Technical training is required<br>
              • Gas planning and staged ascents may be necessary<br><br>

              <em>This dive has been terminated for safety reasons.</em>
            `
          },
           ndlExceeded: {
              icon: "⏱",
              color: "#c62828",
              title: "🚨 No Decompression Limit Exceeded",
              button: "I understand",
              html: `
                <strong>You have exceeded the no-decompression limit.</strong><br><br>

                <strong>Action required:</strong><br>
                • Ascend immediately in a slow and controlled manner<br>
                • Maximum ascent rate: <strong>9–10 m/min</strong><br>
                • Perform a safety stop at <strong>5 m for 3–5 minutes</strong><br><br>

                <em>This dive has been terminated for safety reasons.</em>
              `
            },
             safetyStopInterrupted: {
                title: "Safety stop interrupted",
                text:  "Descend to 5 meters to restart the safety stop.",
                color: "warning"
              },
              safetyStopCompleted: {
                title: "Safety stop completed",
                text: "You can safely continue the ascent.",
                color: "success"
              },
              low_air_reserve_reached: {
                title: "Low Air — Reserve",
                text:
                `Your air reserve is: (≈35 bar).

                • Initiate a slow and controlled ascent
                • No more than 9–10 m/min
                • Prepare your safety stop at 5m
                • Stay calm and breathe slowly`,
                color: "warning"
              }



  },

  // ===================================================
  // LOGS / ESTADOS (visibles o futuros)
  // ===================================================
  logs: {
    decoRequired: "🚨 Decompression was required (recreational criteria)",
    nearNDL: "⚠️ Close to no-decompression limit",
    highTissue: "🟠 High tissue load (physiological model)",
    withinLimits: "✅ Dive within recreational limits"
  },

  // ===================================================
  // ESTADO DE LA INMERSIÓN
  // ===================================================
  diveStatus: {
    completed: "✅ Dive completed",
    failedDeco: "🚨 Dive failed — Decompression was required",
    highTissue: "⚠️ Dive completed — High tissue load",
    nearNDL: "⚠️ Dive completed — Close to no-decompression limit",
    dangerous_ascent: "🚨 At some point you had an uncontrolled ascent. Be careful",
    fast_ascent: "⚠️ At some point you ascended faster than allowed (9 m/min). Always control your ascents and anticipate depth changes"
  },

  // ===================================================
  // SAFETY STOP
  // ===================================================
  safetyStop: {
    title: "Safety stop",
    completed: "✅ <strong>Safety stop completed</strong>",
    notCompleted: "⚠️ <strong>Safety stop not completed</strong>",
    timeAt5m: "Time at 5 m",
    completedAfterInterruptions: "Completed with interruptions",
    back_5m :"⬆️ Return to 5 m",
    hold_5m :"⏸ Stay at 5 m",
    target_depth: "Target depth: 5 m"

  },



   nitrogen_bar: {
    title: "N₂ Load (fast tissues)",

  },

  // ===================================================
  // REPORTE / RESUMEN
  // ===================================================
  report: {
    diveNumber: "Dive",
    time: "Time",
    maxDepth: "Max depth",
    gas: "Gas",
    tank: "Tank",
    startPressure: "Start pressure",
    endPressure: "End pressure",
    airUsed: "Air used",
    sac: "SAC",
    reserveReached: "Reserve reached",
    ceiling: "Ceiling",
    gf: "GF",
    tissueTitle: "Tissue compartments",
    tissueNote:
      "Compartments in red indicate limiting tissues — no mandatory decompression.",
      ceiling :"Ceiling",
    safetystop: "Safety Stop",
    analisis_avanzado: "Advanced Analysis",
    oxigen_tox: "Oxygen Toxicity",
    gradient_factor: "Gradient Factor",
    tejido_lider: "Leading Tissue",
    comparimento_tiempo_medio : "Compartment Halftime",
    tension_tejido: "Tissue Tension",
    tension_max_permitida: "Max Allowed Tension",
    load_perfil: "Profile Load"
  },



  camera_hud: {
    t1: "Adjust Neutral Balance",
    level_ok: "✓ Neutral",
    level_hint: "Tap ⦿ for neutral level"
  },

  // ===================================================
  // PERFIL
  // ===================================================
  profile: {
    title: "Depth profile"
  },

  // ===================================================
  // COMPARTIMENTOS / TISSUES
  // ===================================================
  tissues: {
    title: "Tissue compartments (N₂)",
    surfaceOffGassing: "Surface off-gassing",
    afterInterval: "After",
    minutes: "min",
    offGas: "⬇ off-gassing",
    onGas: "⬆ on-gassing",
    tissues_data_invalidos: "No compartment information"
  },

  // ===================================================
  // INTERVALO DE SUPERFICIE
  // ===================================================
  surface: {
    title: "Simulation Time Scale",
    invalid_interval_surface: "Invalid interval time",
    recalc: "Recalculate tissues",
    after: "After",
    notAllowed: "Repetitive dives are not allowed after this dive"
  },




   scale_time_home: {
    title: "Simulation Time Scale",
      text: `
        This simulator can <strong>speed up time</strong> to facilitate
        the visualization of physiological processes (NDL, nitrogen load,
        ascent behavior) that in real diving take much longer.
        <br><br>
        This does <strong>not</strong> represent real time and is used
        <strong>for educational and visual purposes only</strong>.
      `,
      real_time: "Real",
      choose: "Select the simulation speed:",
      start: "Start dive"
  },







  // ===================================================
  // REPETITIVAS
  // ===================================================
  repetitive: {
    tag: "Repetitive dive",
    info:
      "This dive begins with residual nitrogen from a previous dive. A conservative ascent and a full safety stop are recommended.",
    first_dive: "First Dive",
    repetitive_dive: "Repetitive dive", 
  },

  // ===================================================
  // EDUCACIÓN / AVISO LEGAL (HTML LARGO)
  // ===================================================
  education: {
    longHTML: `
<strong>ℹ️ Why did this message appear?</strong><br><br>

<strong>During this simulation, the profile remained within the displayed no-decompression limits.</strong>
At no point did the dynamic no-decompression limit (NDL) represented by the system
reach zero, nor were mandatory decompression stops generated within the simulated environment.
<br><br>

The message shown <strong>does not indicate an error, a failed dive, or a violation</strong>.
It is strictly informational and is derived from the
<strong>same internal physiological model</strong> applied consistently throughout the simulation.
<br><br>

<strong>How does this simulator work?</strong><br>
This simulator is a <strong>visualization and illustration tool</strong>
intended to present general concepts related to diving physiology.
It is based on a <strong>theoretical continuous tissue-tracking model</strong>,
inspired by widely documented decompression frameworks
(such as Bühlmann ZHL-16C with Gradient Factor logic),
applied exclusively for representative purposes.
<br><br>

During the simulated dive, the system:
<ul style="margin:8px 0 0 18px;">
  <li>Represents relative estimates of inert gas absorption in theoretical tissue compartments</li>
  <li>Shows the proximity of those compartments to modeled limits</li>
  <li>Illustrates how ascent conservatising varies <em>only within the simulation</em></li>
</ul>
<br>

<strong>Why can a notice appear if the NDL was respected?</strong><br>
Even when a decompression obligation is not represented,
the model may show <strong>relatively elevated inert gas loads</strong>
in certain simulated tissues.
This can occur in profiles that include:
<ul style="margin:8px 0 0 18px;">
  <li>Prolonged times at the bottom</li>
  <li>Exposures close to the no-decompression limit</li>
  <li>Moderate depths maintained over long intervals</li>
</ul>
<br>

In these cases, the system may present a
<strong>precautionary informative message</strong>,
whose sole purpose is to provide additional physiological context within the visualization.
This message <strong>does not constitute operational instructions or a diving recommendation</strong>.
<br><br>

<strong>🟠 Important clarification:</strong><br>
This message <strong>does not represent decompression requirements</strong>,
<strong>is not an alarm or an instruction from a dive computer</strong>,
and <strong>does not imply unsafe, incorrect, or non-compliant practices</strong>.
It merely reflects that, within the simulated model,
certain tissues presented a relatively higher inert gas load
compared to a typical short recreational dive.
<br><br>

<strong>In simple terms:</strong><br>
The simulated profile remained within the represented limits.
This message simply indicates:
<em>“This simulated scenario approached a conservative margin, so additional information is shown to contextualize the profile.”</em>
<br><br>

<strong>Legal disclaimer:</strong><br>
This simulator is provided <strong>exclusively for visualization and illustration purposes</strong>.
<strong>It is not a dive computer</strong>,
<strong>does not substitute certified training or the educational role of recognized agencies</strong>,
and <strong>must not be used as a basis for decision-making in real dives</strong>.
`
  },

  // ===================================================
  // PRE-DIVE CHECK
  // ===================================================
  predive: {
    title: "Pre-dive safety check",
    subtitle: "Standard industry pre-dive check (BWRAF) and gas selection",
    selectGas: "Select the breathing gas",
    start: "Start dive",
    cancel: "Cancel & Reset",
    descargar: "Download report",
    bwraf: {
      b: "BCD: inflate / deflate, inflator correct",
      w: "Weights: correct amount, free quick release",
      r: "Releases: straps, buckles, and tank secured",
      a: "Air: valve open, breathe and check pressure",
      f: "Final: mask, fins, computer, buddy ready"
    }
  },


comparativa_tablas_tejidos_bhulmann: {
  text: `
    <div style="display:flex; flex-direction:column; gap:14px; line-height:1.65; color:#eaf4ff;">

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:18px; font-weight:700; margin-bottom:8px;">
          🧠📊 Tables or physiological model?
        </div>
        <div style="font-size:14px; opacity:.95;">
          Both serve to estimate no-decompression time, but <strong>they do not work the same way</strong>.
          That is why they can sometimes show different results.
        </div>
      </div>

      <div style="display:grid; gap:12px;">
        
        <div style="background:rgba(0,153,255,.10); border:1px solid rgba(0,153,255,.25); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🔵 Recreational Tables (PADI / DSAT)
          </div>
          <div style="font-size:14px;">
            <div>⏱️ They give you a <strong>fixed time</strong> based on depth.</div>
            <div>📚 They are based on studies and safety margins.</div>
            <div>🧮 <strong>They do not calculate</strong> your body in real time.</div>
            <div>🟢 They are simple, fast, and easy to understand.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Example: at <strong>20 m</strong>, the table may say <strong>NDL ≈ 45 min</strong>.
          </div>
        </div>

        <div style="background:rgba(0,255,170,.08); border:1px solid rgba(0,255,170,.22); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🟢 Bühlmann Model (this simulator)
          </div>
          <div style="font-size:14px;">
            <div>🧠 Simulates <strong>16 virtual tissues</strong> of the body.</div>
            <div>📈 Calculates in real time how they absorb and release nitrogen.</div>
            <div>⚙️ Adapts to your actual profile: <strong>depth, time, and gas</strong>.</div>
            <div>🎯 That is why it is more dynamic and more realistic.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Here the <strong>NDL is not fixed</strong>: it is calculated as the moment when <strong>a stop would already be required</strong>.
          </div>
        </div>

      </div>

      <div style="background:rgba(255,196,0,.10); border:1px solid rgba(255,196,0,.25); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          ⚠️ Why do they sometimes disagree?
        </div>
        <div style="font-size:14px;">
          <div>📚 Recreational tables are more <strong>conservative</strong>.</div>
          <div>🧠 The Bühlmann model continuously calculates what is happening in the body.</div>
          <div>🔍 That is why the simulator can show a different NDL than a classic table.</div>
        </div>
      </div>

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          💡 In summary
        </div>
        <div style="font-size:14px;">
          <div>🔵 <strong>Tables</strong> = a simple and conservative approximation</div>
          <div>🟢 <strong>Bühlmann</strong> = a more realistic physiological simulation</div>
        </div>

        <div style="margin-top:10px; font-size:14px; font-weight:600;">
          👉 This simulator uses the Bühlmann model to offer a more dynamic estimate of the NDL.
        </div>
      </div>

    </div>
  `
},


block_student: {
    riesgo_accidente_disbarico: "High risk of dysbaric illness",
    riesgo_microburbujas: "Risk of microbubbles",
    reducir_velocidad: "You must reduce the ascent rate to 9m/min",
    ascenso_ideal: "Ideal Rate",
    ascenso_lento: "Slow Ascent. Correct",
    velocidad_asenso: "Ascent rate"


},


dashboard:{
  
    profile_txt: "My profile",
    logout_txt:"Log out",
    welcome_label:"Welcome",
    payments_title:"Payments panel",
    startSimulatorBtn:"🎮 Start dive simulator",
    view_payments:"View Payments",
    view_simulator_logs:"Simulator Logs",
    paymentsEmpty:"Loading payments...",
    response_title:"Payments",
    activo_con_previa_cancelacion: "🎮 Active access (scheduled cancellation)",
    fecha_cancelacion_suscripcion: "⚠️ Your subscription will cancel on:",
    en_proceso_cancelacion: "🟠 Subscription in the process of cancellation",
    acceso_hasta: "Access available until:",
    despues_esta_fecha_no_acceso: "After this date, access will be lost automatically",
    suscripcion_finalizada: "💳 Subscription ended",
    suscripcion_cancelada: "🔴 Subscription cancelled",
    acceso_habiliatdo: "🟢 Access enabled:",
    upgrade_plan : "Modify my plan",
    modificar_a :"Change to:",
    tienes_el_plan_maximo: "✨ You have the maximum plan available.",
    reactivar_suscripcion: "🔄 Reactivate subscription",
    cancelar_suscripcion: "❌ Cancel subscription",
    en_proceso: "⏳ Processing...",
    cancelando: "⏳ Cancelling...",
    cancelada: "✅ Cancelled",
    error: "❌ Error",
    reactivando_suscripcion: "⏳ Reactivating...",
    reactivada: "✅ Reactivated",
    no_pagos_aun: "No payments recorded yet.",
    pagar: "💳 Pay",
    pagado: "💳 Credited",
    activar_acceso_simulador: "💳 Activate simulator access",
    sin_suscripcion_inactiva: "🔴 No active subscription",
    membresia_title: "Membership",
    credits_title: "Credits",
    add_saldo: "Add Credits"

},


instructor_safety: {
    quiz_1_question: "Se detectó una inmersión profunda sin parada de seguridad efectiva. ¿Cuál es la implicación fisiológica principal?",
    riesgo_microburbujas: "Risk of microbubbles",
    reducir_velocidad: "You must reduce ascent rate to 9m/min",
    ascenso_ideal: "Ideal Ascent Rate",
    ascenso_lento: "Slow Ascent. Correct",
    ascent_rate: "Ascent rate"
},


instructor_gas: {
    riesgo_accidente_disbarico: "High risk of decompression sickness",
    riesgo_microburbujas: "Risk of microbubbles",
    reducir_velocidad: "You must reduce ascent rate to 9m/min",
    ascenso_ideal: "Ideal Ascent Rate",
    ascenso_lento: "Slow Ascent. Correct",
    ascent_rate: "Ascent rate"
},


instructor_tissues: {
    riesgo_accidente_disbarico: "High risk of decompression sickness",
    riesgo_microburbujas: "Risk of microbubbles",
    reducir_velocidad: "You must reduce ascent rate to 9m/min",
    ascenso_ideal: "Ideal Ascent Rate",
    ascenso_lento: "Slow Ascent. Correct",
    ascent_rate: "Ascent rate"
},


instructor_deco: {
    riesgo_accidente_disbarico: "High risk of decompression sickness",
    riesgo_microburbujas: "Risk of microbubbles",
    reducir_velocidad: "You must reduce ascent rate to 9m/min",
    ascenso_ideal: "Ideal Ascent Rate",
    ascenso_lento: "Slow Ascent. Correct",
    ascent_rate: "Ascent rate"
},

instructor_ascent: {
    riesgo_accidente_disbarico: "High risk of decompression sickness",
    riesgo_microburbujas: "Risk of microbubbles",
    reducir_velocidad: "You must reduce ascent rate to 9m/min",
    ascenso_ideal: "Ideal Ascent Rate",
    ascenso_lento: "Slow Ascent. Correct",
    ascent_rate: "Ascent rate"
},






}
